/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.inscriptionAnticipee.ts
 *
 * Messages de la phase d'inscription anticipée des candidats : accueil
 * « Mon compte » de la personne inscrite avant l'ouverture, et réglage
 * correspondant au back-office. Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-23
 */
export const messagesInscriptionAnticipeeFr: Record<string, string> = {
  'monCompte.titre': 'Votre compte est créé',
  'monCompte.titre.avecPrenom': 'Bienvenue {prenom}, votre compte est créé',
  'monCompte.sousTitre.ferme':
    '{evenement} ouvre ses portes le {date}. D’ici là, préparez votre venue : complétez votre profil, déposez votre CV, gardez votre badge sous la main. Les entreprises exposantes pourront vous repérer dès l’ouverture.',
  'monCompte.sousTitre.ouvert':
    'Complétez votre profil, déposez votre CV et gardez votre badge sous la main.',

  'monCompte.profil.titre': 'Votre profil',
  'monCompte.profil.texte':
    'Ce que vous recherchez, votre secteur, votre expérience. C’est ce qui permet aux entreprises de vous proposer les bons postes.',
  'monCompte.profil.lien': 'Compléter mon profil',

  'monCompte.cv.titre': 'Votre CV',
  'monCompte.cv.texte':
    'Déposez votre CV, puis choisissez qui peut le consulter : personne, les entreprises dont vous scannez le stand, ou toutes les entreprises exposantes. Vous pouvez changer d’avis à tout moment.',
  'monCompte.cv.texteDepose':
    'Votre CV est enregistré. Vous pouvez le remplacer, et changer à tout moment qui peut le consulter.',
  'monCompte.cv.lien': 'Déposer mon CV',
  'monCompte.cv.lienRemplacer': 'Voir ou remplacer mon CV',

  'monCompte.badge.titre': 'Votre badge',
  'monCompte.badge.texte':
    'Votre badge d’entrée, avec son QR code. Présentez-le à l’entrée le jour J, sur votre téléphone ou imprimé.',
  'monCompte.badge.lien': 'Voir mon badge',

  'monCompte.revenir':
    'Vous pouvez revenir quand vous voulez : rendez-vous sur la page de connexion, entrez votre adresse, vous recevrez un code à six chiffres par courriel.',

  'settingsAdmin.earlySignup.label':
    'Ouvrir l’inscription des candidats avant l’ouverture au public',
  'settingsAdmin.earlySignup.off':
    'Fermée : personne ne peut s’inscrire tant que l’application n’est pas ouverte au public',
  'settingsAdmin.earlySignup.on':
    'Ouverte : les candidats s’inscrivent et déposent leur CV dès maintenant',
  'settingsAdmin.earlySignup.help':
    'Les personnes en recherche d’emploi, d’alternance ou de stage peuvent créer leur compte, déposer leur CV et obtenir leur badge, même si l’application n’est pas encore ouverte au public. Le programme, les exposants et la carte leur restent fermés.',
  'settingsAdmin.earlySignupRoles.label':
    'Cartes d’inscription ouvertes pendant cette phase',
  'settingsAdmin.earlySignupRoles.help':
    'Liste séparée par des virgules. Par défaut « visitor », la carte du grand public : c’est elle qui porte le formulaire des candidats (demandeur d’emploi, reconversion, étudiant, lycéen, alternance). Les autres cartes restent fermées tant qu’elles ne sont pas citées ici.',
};
